import { themeAlpine, type ThemeDefaultParams } from "ag-grid-community";

import { skydsGridIcons } from "./aggrid_skyds_icons";

const skydsTheme = {
  accentColor: "#051766ff",
  advancedFilterBuilderButtonBarBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  advancedFilterBuilderColumnPillColor: "#dff5e5ff",
  advancedFilterBuilderIndentSize: 32,
  advancedFilterBuilderJoinPillColor: "#ffe3e3ff",
  advancedFilterBuilderOptionPillColor: "#ffe8c9ff",
  advancedFilterBuilderValuePillColor: "#bce4f7ff",
  backgroundColor: "#ffffffff",
  borderColor: "#d9d9d9ff",
  borderRadius: 3,
  browserColorScheme: undefined,
  buttonActiveBackgroundColor: "#051766ff",
  buttonActiveTextColor: "#ffffffff",
  buttonBackgroundColor: "#ddf1fbff",
  buttonBorder: {
    width: 1,
    color: "#ddf1fbff",
    style: "solid",
  },
  buttonBorderRadius: 3,
  buttonDisabledBackgroundColor: "#d9d9d9ff",
  buttonDisabledTextColor: "#a4a4a4ff",
  buttonFontWeight: 400,
  buttonHorizontalPadding: 16,
  buttonHoverBackgroundColor: "#ddf1fbb3",
  buttonHoverTextColor: "#051766ff",
  buttonTextColor: "#051766ff",
  buttonVerticalPadding: 8,
  cellEditingBorder: {
    width: 1,
    color: "#051766ff",
    style: "solid",
  },
  cellFontFamily: "inherit",
  cellHorizontalPadding: 16,
  cellHorizontalPaddingScale: 1,
  cellTextColor: "#252525ff",
  cellWidgetSpacing: 12,
  chartMenuPanelWidth: 260,
  checkboxBorderRadius: 2,
  checkboxBorderWidth: 2,
  checkboxCheckedBackgroundColor: "#051766ff",
  checkboxCheckedShapeColor: "#ffffffff",
  checkboxIndeterminateShapeColor: "#ffffffff",
  checkboxUncheckedBackgroundColor: "#ffffffff",
  checkboxUncheckedBorderColor: "#051766ff",
  columnBorder: {
    width: 1,
    color: "#ffffff00",
    style: "solid",
  },
  columnDropCellBackgroundColor: "#25252514",
  columnDropCellBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  columnDropCellDragHandleColor: "#252525ff",
  columnDropCellTextColor: "#252525ff",
  columnHoverColor: "#e6e7efff",
  columnSelectIndentSize: 16,
  dataFontSize: 14,
  dialogBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  dragAndDropImageBackgroundColor: "#ffffffff",
  dragAndDropImageBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  dragHandleColor: "#252525b3",
  filterToolPanelGroupIndent: 8,
  findActiveMatchBackgroundColor: "#374585ff",
  findActiveMatchColor: "#374585ff",
  findMatchBackgroundColor: "#374585ff",
  findMatchColor: "#252525ff",
  focusShadow: 0,
  fontFamily: "inherit",
  fontSize: 13,
  footerRowBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  foregroundColor: "#252525ff",
  headerBackgroundColor: "#f7f7f7ff",
  headerCellHoverBackgroundColor: "#e6e7efff",
  headerColumnBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  headerColumnBorderHeight: 0,
  headerColumnResizeHandleHeight: 14,
  headerColumnResizeHandleWidth: 2,
  headerFontFamily: "inherit",
  headerFontSize: 13,
  headerFontWeight: 700,
  headerHeight: 48,
  headerRowBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  headerVerticalPaddingScale: 1,
  iconButtonActiveBackgroundColor: "#5e5e5e1a",
  iconButtonActiveColor: "#5e5e5e1a",
  iconButtonActiveIndicatorColor: "#ffffffff",
  iconButtonBackgroundColor: "#ffffff00",
  iconButtonBackgroundSpread: 4,
  iconButtonBorderRadius: 1,
  iconButtonColor: "#ffffff00",
  iconButtonHoverBackgroundColor: "#5e5e5e12",
  iconButtonHoverColor: "#5e5e5e12",
  iconColor: "#252525ff",
  iconSize: 16,
  inputBackgroundColor: "#ffffffff",
  inputBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  inputBorderRadius: 3,
  inputDisabledBackgroundColor: "#d9d9d9ff",
  inputDisabledBorder: {
    width: 1,
    color: "#a4a4a4ff",
    style: "solid",
  },
  inputDisabledTextColor: "#a4a4a4ff",
  inputFocusBorder: {
    width: 1,
    color: "#051766ff",
    style: "solid",
  },
  inputFocusShadow: 0,
  inputHeight: 32,
  inputIconColor: "#252525ff",
  inputInvalidBorder: {
    width: 1,
    color: "#da291cff",
    style: "solid",
  },
  inputPaddingStart: 8,
  inputPlaceholderTextColor: "#5e5e5eff",
  inputTextColor: "#252525ff",
  invalidColor: "#da291cff",
  listItemHeight: 24,
  menuBackgroundColor: "#f7f7f7ff",
  menuBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  menuShadow: 0,
  oddRowBackgroundColor: "#ffffffff",
  panelTitleBarBorder: {
    width: 1,
    color: "#d9d9d933",
    style: "solid",
  },
  panelTitleBarFontWeight: 700,
  pinnedColumnBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  pinnedRowBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  popupShadow: 0,
  rangeHeaderHighlightColor: undefined,
  rangeSelectionBackgroundColor: "#eef8fd33",
  rangeSelectionBorderColor: "#051766ff",
  rangeSelectionHighlightColor: "#eef8fd66",
  rowBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  rowGroupIndentSize: 28,
  rowHeight: 42,
  rowHoverColor: "#e6e7efff",
  rowLoadingSkeletonEffectColor: "#25252514",
  rowVerticalPaddingScale: 16,
  selectCellBorder: {
    width: 1,
    color: "#e6e7efff",
    style: "solid",
  },
  selectedRowBackgroundColor: "#ddf1fbff",
  setFilterIndentSize: 16,
  sideBarBackgroundColor: "#ffffffff",
  sideBarPanelWidth: 250,
  sideButtonBarTopPadding: 24,
  sideButtonHoverBackgroundColor: "#ffffffff",
  sideButtonSelectedBackgroundColor: "#ffffff00",
  sideButtonSelectedUnderlineColor: "#051766ff",
  sidePanelBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  spacing: 8,
  statusBarLabelColor: "#252525ff",
  statusBarLabelFontWeight: 500,
  statusBarValueColor: "#252525ff",
  statusBarValueFontWeight: 500,
  subtleTextColor: "#252525ff",
  tabBackgroundColor: "#ffffff00",
  tabBarBackgroundColor: "#f7f7f7ff",
  tabBarBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  tabBarHorizontalPadding: 0,
  tabBarTopPadding: 8,
  tabBottomPadding: 8,
  tabHorizontalPadding: 0,
  tabHoverBackgroundColor: "#ededdff",
  tabSelectedBorderWidth: 0,
  tabSelectedTextColor: "#252525ff",
  tabSelectedUnderlineColor: "#ffffff00",
  tabSelectedUnderlineTransitionDuration: 0,
  tabSelectedUnderlineWidth: 1,
  tabSpacing: 8,
  tabTopPadding: 18,
  toggleButtonHeight: 18,
  toggleButtonOffBackgroundColor: "#97999aff",
  toggleButtonOnBackgroundColor: "#051766ff",
  toggleButtonSwitchBackgroundColor: "#ffffffff",
  toggleButtonSwitchInset: 1,
  toggleButtonWidth: 28,
  toolPanelSeparatorBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  tooltipBackgroundColor: "#fafbfbff",
  tooltipBorder: {
    width: 1,
    color: "#252525ff",
    style: "solid",
  },
  valueChangeDeltaDownColor: "#da291cff",
  valueChangeDeltaUpColor: "#28794eff",
  valueChangeValueHighlightBackgroundColor: "#ddf1fb80",
  widgetContainerHorizontalPadding: 12,
  widgetContainerVerticalPadding: 12,
  widgetHorizontalSpacing: 12,
  widgetVerticalSpacing: 8,
  wrapperBorder: {
    width: 1,
    color: "#d9d9d9ff",
    style: "solid",
  },
  wrapperBorderRadius: 0,
};

export const skydsGridTheme = themeAlpine
  .withParams(skydsTheme as Partial<ThemeDefaultParams>)
  .withParams ({
    headerHeight: 29,
    rowHeight: 29,
    cellFontSize: "13px",
    iconButtonActiveBackgroundColor: "#ddf1fbff", // #5e5e5e1a => #2196f347
    iconButtonActiveColor: "#051766ff", // #5e5e5e1a => #2196f3ff
    iconButtonActiveIndicatorColor: "#da291cff", //#ffffffff =>  #2196f3ff
  })
  .withPart(skydsGridIcons);
